const pagination = {
  dense: "Dense",
  rows_per_page: "Lignes par page",
  on: "sur",
};
export default pagination;
